import React from 'react'

const LoveUserItem = (props) => {
  return (
    <div className="flex items-center gap-5">
        <img src={props.data.pic} alt={`${props.data.name} Profile Pic`} className="w-10 h-10 rounded-full" />
        <div>
          <span className="font-semibold">{props.data.name} </span> 
          menyukai konten ini.
        </div>
    </div>
  )
}

export default LoveUserItem